import axios from 'axios'

const API_PATH = 'admins/fast_sell/products'

const FastSellProductApi = {
  /**
   * Get list of `Fast Sell Products`
   * @param {object} params uri parameter
   * @return {object} Collection of `Fast Sell Products`
   */
  index: async (params) => {
    const response = axios.get(API_PATH, { params })
    return response
  },
  /**
   * Create a Fast Sell Product's outbound
   * Invoke `GET admins/fast_sell/products/:id`
   */
  show: async ({ id: id }) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },
  /**
   * Create a Fast Sell Product's outbound
   * Invoke `POST admins/fast_sell/products`
   */
  create: async (values) => {
    const params   = {
      fast_sell_product: {
        name                : values.name,
        product_brand_id    : values.product_brand_id,
        product_category_id : values.product_category_id,
        condition           : values.condition,
        details             : values.details,
        serial_code         : values.serial_code,
        price_offer         : values.price_offer,
        year_purchased      : values.year_purchased,
        status              : values.status,
        received_status     : values.received_status,
        note                : values.note,
        images              : values.images
      },
      seller_id: values.seller_id
    }
    const response = axios.post(API_PATH, params)
    return response
  },
  /**
   * Update Fast Sell Product's attributes
   * Invoke `PATCH admins/fast_sell/:id/products/update`
   */
  update: async (values) => {
    const params   = {
      fast_sell_product: {
        id                  : values.id,
        name                : values.name,
        product_brand_id    : values.product_brand_id,
        product_category_id : values.product_category_id,
        condition           : values.condition,
        details             : values.details,
        serial_code         : values.serial_code,
        year_purchased      : values.year_purchased,
        status              : values.status,
        received_status     : values.received_status,
        note                : values.note,
        images              : values.images
      },
      seller_id: values.seller_id
    }
    const response = axios.patch(API_PATH, params)
    return response
  },
  /**
   * Update Fast Sell Product's price offers
   * Invoke `PATCH admins/fast_sell/:id/products/price_offers`
   */
  priceOffers: async ({ fastSellProductId, priceOffers }) => {
    const path         = `${API_PATH}/${fastSellProductId}/price_offers`
    const price_offers = priceOffers.map((priceOffer) => ({
      id        : priceOffer.id,
      price     : priceOffer.price,
      status    : priceOffer.status,
      user_type : priceOffer.user.user_type,
      destroy   : priceOffer.destroy
    }))
    const params       = {
      fast_sell_product: {
        price_offers: price_offers
      }
    }
    const response     = axios.patch(path, params)
    return response
  },
  /**
   * Update Fast Sell Product's status
   * Invoke `PATCH admins/fast_sell/:id/products/status`
   */
  status: async ({ fastSellProductId, status }) => {
    const path     = `${API_PATH}/${fastSellProductId}/status`
    const params   = {
      fast_sell_product: {
        status: status
      }
    }
    const response = axios.patch(path, params)
    return response
  },
  /**
   * Update Fast Sell Product's receive status
   * Invoke `PATCH admins/fast_sell/:id/products/receive`
   */
  receive: async ({ fastSellProductId }) => {
    const path     = `${API_PATH}/${fastSellProductId}/receive`
    const response = axios.patch(path)
    return response
  },
  /**
   * Update Fast Sell Product's inbound
   * Invoke `PATCH admins/fast_sell/:id/products/inbound`
   */
  inbound: async ({ fastSellProductId, values }) => {
    const path     = `${API_PATH}/${fastSellProductId}/inbound`
    const params   = {
      fast_sell_product: {
        inbound_courier     : values.inbound_courier,
        inbound_shipping_no : values.inbound_shipping_no
      }
    }
    const response = axios.patch(path, params)
    return response
  },
  /**
   * Update Fast Sell Product's curation
   * Invoke `PATCH admins/fast_sell/:id/products/curation`
   */
  curation: async ({ fastSellProductId, values }) => {
    const path     = `${API_PATH}/${fastSellProductId}/curation`
    const params   = {
      fast_sell_product: {
        curation_status        : values.curation_status,
        curation_reject_label  : values.curation_reject_label,
        curation_reject_reason : values.curation_reject_reason
      }
    }
    const response = axios.patch(path, params)
    return response
  },
  /**
   * Update Fast Sell Product's outbound
   * Invoke `PATCH admins/fast_sell/:id/products/outbound`
   */
  outbound: async ({ fastSellProductId, values }) => {
    const path     = `${API_PATH}/${fastSellProductId}/outbound`
    const params   = {
      fast_sell_product: {
        outbound_courier     : values.outbound_courier,
        outbound_shipping_no : values.outbound_shipping_no
      }
    }
    const response = axios.patch(path, params)
    return response
  },
  /**
   * Reject a Fast Sell Product
   * Invoke `PATCH admins/fast_sell/products/:id/reject`
   */
  reject: async ({ fastSellProductId, values }) => {
    const path     = `${API_PATH}/${fastSellProductId}/reject`
    const params   = {
      fast_sell_product: {
        status_reject_reason : values.status_reject_reason,
        ops_notes            : values.ops_notes
      }
    }
    const response = axios.patch(path, params)
    return response
  },
  /**
   * Update Fast Sell Product's Entrupy Image
   * Invoke `PATCH admins/fast_sell/products/:id/verification_status`
   */
  verificationStatus: async (
    id,
    verificationStatus
  ) => {
    const path     = `${API_PATH}/${id}/verification_status`
    const params   = {
      fast_sell_product: {
        verification_status: verificationStatus
      }
    }
    const response = axios.patch(path, params)
    return response
  },
  /**
   * Update Fast Sell Product's Entrupy Image
   * Invoke `PATCH admins/fast_sell/products/:id/entrupy`
   */
  entrupy: async ({
    fastSellProductId,
    entrupyImage
  }) => {
    const path     = `${API_PATH}/${fastSellProductId}/entrupy`
    const formData = new FormData()
    formData.append('fast_sell_product[entrupy_image]', entrupyImage)

    const response = axios.patch(path, formData)
    return response
  }
}

export default FastSellProductApi
